import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { IconArrowDownOutline, IconArrowLeftOutline, IconArrowRightOutline, IconArrowUpOutline, IconMail, IconMailOutline, IconPlay, IconPlayCircle, IconPlayCircleOutline, IconPlayOutline, IconPointerDown, IconPointerDownOutline, IconPointerUp, IconPointerUpOutline, IconSmartphone, IconSmartphoneOutline, Button as Button$1, TextButton } from '@zillow/constellation';
import { event } from '@zillow/universal-analytics';
import { yieldCallback } from '@zillow/yield-callback';
import { usePageProps, getCmsInfoForPage } from '@zillow/zrs-cms';
import PropTypes from 'prop-types';
import React from 'react';
import { withTrigger } from '../../util/helpers.js';
import { usePopulateParamPlaceHolders } from '../../util/populateParamPlaceholders.js';

var _excluded = ["content", "link", "component", "icon"];
var Components = {
  Button: Button$1,
  TextButton: TextButton
};
var IconList = {
  IconArrowDownOutline: IconArrowDownOutline,
  IconArrowLeftOutline: IconArrowLeftOutline,
  IconArrowRightOutline: IconArrowRightOutline,
  IconArrowUpOutline: IconArrowUpOutline,
  IconMail: IconMail,
  IconMailOutline: IconMailOutline,
  IconPlay: IconPlay,
  IconPlayCircle: IconPlayCircle,
  IconPlayCircleOutline: IconPlayCircleOutline,
  IconPlayOutline: IconPlayOutline,
  IconPointerDown: IconPointerDown,
  IconPointerDownOutline: IconPointerDownOutline,
  IconPointerUp: IconPointerUp,
  IconPointerUpOutline: IconPointerUpOutline,
  IconSmartphone: IconSmartphone,
  IconSmartphoneOutline: IconSmartphoneOutline
};
var BlockButton = function BlockButton(props) {
  var pageProps = usePageProps();
  var attrs = props.attrs,
    index = props.index;
  var _attrs$content = attrs.content,
    content = _attrs$content === void 0 ? 'Button Text' : _attrs$content,
    link = attrs.link,
    _attrs$component = attrs.component,
    component = _attrs$component === void 0 ? 'Button' : _attrs$component,
    icon = attrs.icon,
    restAttrs = _objectWithoutProperties(attrs, _excluded);
  var ButtonComponent = Components[component];
  var IconComponent = icon ? IconList[icon] : null;
  var attributes = Object.assign({
    size: 'md',
    buttonType: 'primary',
    iconPosition: 'end'
  }, restAttrs, {
    // Override string icon value with component
    icon: IconComponent ? /*#__PURE__*/React.createElement(IconComponent, null) : undefined
  });
  var href = usePopulateParamPlaceHolders((link === null || link === void 0 ? void 0 : link.url) || link);
  // If a link was provided, set the hyperlink props
  if (link) {
    attributes.as = 'a';
    attributes.href = href;
    attributes.target = link !== null && link !== void 0 && link.opensInNewTab ? '_blank' : undefined;
  }
  var ButtonWithTrigger = withTrigger(ButtonComponent);
  return /*#__PURE__*/React.createElement(ButtonWithTrigger, _extends({
    triggerLink: (link === null || link === void 0 ? void 0 : link.url) || link,
    key: index,
    type: "button"
  }, attributes, {
    onMouseEnter: function onMouseEnter() {
      event({
        // https://dataportal.zillowgroup.net/event-registry/2049
        envelope: {
          event_type_id: '2049',
          event_type_version_id: '1',
          event_template_id: '126',
          event_template_version_id: '1'
          // Master ID: 2284.2.126.1
        },
        clickstream_trigger: {
          trigger_type_nm: 'interaction',
          trigger_location_nm: 'cms',
          trigger_source_nm: 'cms_button',
          trigger_object_nm: 'no_trigger_object'
        },
        semantic: {
          semantic_event_nm: 'cms_hover'
        },
        cms_info: Object.assign({
          block_id: attributes.id || '',
          block_type_cd: 'button',
          block_displayed_txt: content,
          block_target_url: (link === null || link === void 0 ? void 0 : link.url) || link,
          block_target_window_txt: link !== null && link !== void 0 && link.opensInNewTab ? '_blank' : ''
        }, getCmsInfoForPage(pageProps))
      });
    },
    onClick: yieldCallback(function (e) {
      event({
        // https://dataportal.zillowgroup.net/event-registry/2048
        envelope: {
          event_type_id: '2048',
          event_type_version_id: '1',
          event_template_id: '126',
          event_template_version_id: '1'
          // Master ID: 2284.2.126.1
        },
        clickstream_trigger: {
          trigger_type_nm: 'interaction',
          trigger_location_nm: 'cms',
          trigger_source_nm: 'cms_button',
          trigger_object_nm: 'no_trigger_object'
        },
        semantic: {
          semantic_event_nm: 'cms_click'
        },
        cms_info: Object.assign({
          block_id: e.target.id || '',
          block_type_cd: 'button',
          block_displayed_txt: e.target.textContent,
          block_target_url: (link === null || link === void 0 ? void 0 : link.url) || link,
          block_target_window_txt: link !== null && link !== void 0 && link.opensInNewTab ? '_blank' : ''
        }, getCmsInfoForPage(pageProps))
      });
    })
  }), content);
};
BlockButton.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    content: PropTypes.string,
    link: PropTypes.string,
    component: PropTypes.string
  }),
  index: PropTypes.number
} : {};
var Button = withTrigger(BlockButton);

export { Button as default };
